module.exports = __webpack_public_path__ + "img/curas.3ee498c6.jpg";